import { useContext, useState, useEffect } from "react";
import { MovementContext } from "../../context/movementContext/MovementContext";
import { useParams } from "react-router-dom";
import { getMovementRetourAutreDecharge } from "../../context/movementContext/apiCalls";
import AdminSideBar from "../../components/adminSideBar/AdminSideBar";
import ErrorComponent from "../../components/errorComponent/ErrorComponent";
import FormInput from "../../components/formInput/FormInput";
import ImageLoader from "../../components/imageLoader/ImageLoader";


export default function DetailDechargeRetourAutre() {
    const { id } = useParams();
    const { dispatch, movementDecharge, isFetchingGetDecharge, errorGetDecharge } = useContext(MovementContext)
    const [errorBox, setErrorBox] = useState("");

    const [motif, setMotif] = useState("");
    const [montant, setMontant] = useState("");
    const [file, setFile] = useState(null);

    useEffect(() => {
        getMovementRetourAutreDecharge(dispatch, id);
    }, [id])

    useEffect(() => {
        if (errorGetDecharge !== "") {
            setErrorBox(errorGetDecharge)
        }
    }, [errorGetDecharge])

    useEffect(() => {
        if (!isFetchingGetDecharge) {
            if (Object.keys(movementDecharge).length !== 0) {
                setMontant(movementDecharge.montant);
                setMotif(movementDecharge.motif);
            }
        }
    }, [movementDecharge])

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="movement" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Détail Déchargement :</span>
                </div>

                {errorBox && <ErrorComponent error={errorBox} />}

                <div className="content invoice" style={{ marginTop: '20px' }}>
                    <div className="box" style={{ width: '600px' }}>
                        <div className="box-content">
                            <FormInput label='Montant' itemInput={montant} setItemInput={setMontant} auth istype='number' inactive />
                            <FormInput label='Motif' itemInput={motif} setItemInput={setMotif} auth inactive/>
                            <ImageLoader imageLabel={"Attacher Image"} fileDecharge={file} setFileDecharge={setFile}  imgUrl={movementDecharge.image} subPath='uploadDecharge' downloadIcon={true} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
